import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { useQuery } from '@apollo/client/react';
import { useEffect } from 'react';
import type { IntermodalDetailsQueryQuery } from '../../../gql/graphql';
import { intermodalBookingQuery } from '../graphql/intermodalQuery';

export const useIntermodalBookingsDetails = (
  bookingNo: number,
  onCompleted: (data: IntermodalDetailsQueryQuery) => void,
) => {
  const { data, error, loading, refetch } = useQuery(intermodalBookingQuery, {
    fetchPolicy: 'network-only',
    variables: { bookingNo },
  });
  useEffect(() => {
    if (data) onCompleted(data);
  }, [data, onCompleted]);
  return {
    booking: data?.viewer?.intermodalBookings?.booking,
    error: CombinedGraphQLErrors.is(error) ? error.errors[0] : undefined,
    loading,
    refetch,
  };
};
